<template>
  <div class="event">
    <div class="event-container">
      <div class="top-banner">
        <van-nav-bar 
          left-text="返回" 
          :title="statTitle"
          left-arrow 
          @click-left="onClickLeft"
        >
        </van-nav-bar>
      </div>
      <div class="event-player">
        <div class="video_container">
          <video :src="videoUrl" controls v-if="videoUrl" 
            controlsList="nodownload noremoteplayback"
            disableremoteplayback
            disablepictureinpicture
          />
        </div>
      </div>
      <div class="action-list">
        <van-cell-group>
          <van-cell size="large" icon="video-o" title="活动统计" is-link :to="'/DisEventStat/' + evt_id" />
        </van-cell-group>
        <div style="margin-top: 12px;padding: 10px; background: #fff; border-bottom: 3px solid #ccc; text-align : center">本期题库</div>
        <div class="question" v-for="q in event.questions" :key="q.id">
          <van-cell>问题：{{ q.question }}</van-cell>
          <van-radio-group>
            <van-cell-group>
              <van-cell><span :style="q.correct == 'A' ? { color: 'red' } : {}">
                A. {{ q.answerA }}
              </span></van-cell>
              <van-cell><span :style="q.correct == 'B' ? { color: 'red' } : {}">
                B. {{ q.answerB }}
              </span></van-cell>
              <van-cell><span :style="q.correct == 'C' ? { color: 'red' } : {}">
                C. {{ q.answerC }}
              </span></van-cell>
              <van-cell><span :style="q.correct == 'D' ? { color: 'red' } : {}">
                D. {{ q.answerD }}
              </span></van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>

        <!--
        <div class="logout-function">
          <van-button plain type="info" block @click="doLogout">退出</van-button>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { eventInfo, eventStat } from '@/api/event'

export default {
  name: 'SupportDetail',
  data() {
    return {
      evt_id: 0,
      event: {
        name: ''
      }
    }
  },
  computed: {
    ...mapState(['user']),
    statTitle() {
      return this.event.name;
    },
    res_url() {
      return window.__config__.res_url;
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.evt_id = this.$route.params.id;
      this.loadData(this.evt_id)
    },
    onClickLeft() {
      this.$router.back();
    },
    loadData(evt_id) {
      eventInfo(evt_id).then(resp => {
        this.event = resp.data
        this.videoUrl = window.__config__.video_url + this.event.video.file_key;
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.event-container {
  height: calc(100vh - 60px);
  width: 100%;
  display: flex;
  flex-direction: column;
  
  .view-function {
    margin: 20px;
  }


  .video_container {
    margin: 5px auto;
    width: 100vw;
    height: 58vw;
    video {
      width: 100%;
    }
  }
  .action-list {
    padding: 5px 0;

    .action-title {
      padding: 0 0 5px 0;
      margin: 10px 0 15px 0;
      font-size: 16px;
      border-bottom: 4px solid #73b684;
      display: inline-block;
    }
  }
  
}
</style>
